import { UrlUtils } from '@dpdgroupuk/cc-dpd-ui';

// Check if app is in development mode
export const IS_DEV_MODE =
  import.meta.env.MODE === 'development' || import.meta.env.DEV;

export const DEV_APIS_BASE_URL = 'http://localhost:8030';
export const DEV_AUTH_BASE_URL = 'http://localhost:8031';
export const DEV_CHAT_BASE_URL = 'http://localhost:8032';
export const DEV_CHATPROXY_BASE_URL = 'http://localhost:8033';
export const DEV_ENHANCEDCHAT_BASE_URL = 'http://localhost:8034';
export const DEV_CITYSPRINT_BASE_URL = 'http://localhost:8035';

export const APIS_BASE_URL = IS_DEV_MODE
  ? DEV_APIS_BASE_URL
  : import.meta.env.VITE_APIS_URL;

export const AUTH_BASE_URL = IS_DEV_MODE
  ? DEV_AUTH_BASE_URL
  : import.meta.env.VITE_APIS_URL;

export const CHAT_BASE_URL = IS_DEV_MODE
  ? DEV_CHAT_BASE_URL
  : import.meta.env.VITE_APIS_URL;

export const CITYSPRINT_BASE_URL = IS_DEV_MODE
  ? DEV_CITYSPRINT_BASE_URL
  : import.meta.env.VITE_APIS_URL;

export const CHATPROXY_BASE_URL = IS_DEV_MODE
  ? DEV_CHATPROXY_BASE_URL
  : import.meta.env.VITE_APIS_URL;

export const ENHANCED_CHAT_BASE_URL = IS_DEV_MODE
  ? DEV_ENHANCEDCHAT_BASE_URL
  : import.meta.env.VITE_ENHANCED_CHAT_API_URL;

export const MAX_BASKET_ITEMS = parseInt(import.meta.env.VITE_MAX_BASKET_ITEMS);

export const FMP_BASE_URL = UrlUtils.getEnvBaseUrl('track.dpd.co.uk', {
  localhostOverride: 'https://d1-track.dpd.co.uk',
});

const loginBase = UrlUtils.getEnvBaseUrl('login.dpd.co.uk', {
  localhostOverride: 'http://localhost:3000/',
});
export const SIGN_IN_BASE_URL = loginBase.endsWith('/')
  ? loginBase
  : `${loginBase}/`;

export const CHAT_CONFIG = {
  chatBotHost: CHAT_BASE_URL,
  chatProxyHost: CHATPROXY_BASE_URL,
  apisBaseUrl: IS_DEV_MODE ? DEV_APIS_BASE_URL : import.meta.env.VITE_APIS_URL,
  client: import.meta.env.VITE_REACT_APP_SF_AUTH_CLIENT_ID,
  businessUnit: 2,
  ratingType: 'FMP',
  isSalesforceCaseRequired: false,
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  apiVersion: parseInt(import.meta.env.VITE_REACT_APP_SF_API_VERSION),
  enhancedChatBaseUrl: ENHANCED_CHAT_BASE_URL,
  additionalDetails: {
    platform: import.meta.env.VITE_REACT_APP_SF_PLATFORM,
    reason: 'DPD Online',
  },
  ssePingMs: import.meta.env.VITE_SSE_PING_MS
    ? parseInt(import.meta.env.VITE_SSE_PING_MS)
    : 30000,
  liveagent: {
    host: import.meta.env.VITE_REACT_APP_SF_LIVEAGENT_URL,
    organizationId: import.meta.env.VITE_REACT_APP_SF_ORGANIZATION,
    eliteDeploymentId: import.meta.env.VITE_REACT_APP_SF_DEPLOYMENT_ID,
    platinumDeploymentId: import.meta.env.VITE_REACT_APP_SF_DEPLOYMENT_ID,
    eliteButtonId: import.meta.env.VITE_REACT_APP_SF_BUTTON_ID,
    platinumButtonId: import.meta.env.VITE_REACT_APP_SF_BUTTON_ID,
    apiVersion: parseInt(import.meta.env.VITE_REACT_APP_SF_API_VERSION, 10),
  },
};

export const DEV_VIEW_SWITCHER =
  import.meta.env.VITE_DEV_VIEW_SWITCHER === 'true';

export const CDN_BASE_URL = import.meta.env.VITE_CDN_BASE_URL;
export const CDN_BASE_URL_IMAGES = `${CDN_BASE_URL}/images`;
export const CDN_BASE_URL_VIDEO = `${CDN_BASE_URL}/video`;

export const CDN_IMAGE_FOOTER_GOOGLE_PAY = `${CDN_BASE_URL_IMAGES}/footerGooglePay.png`;
